var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "clearfix p-20 p-b-0" }, [
    _c("div", { class: ["col-xs-8 col-md-6 p-0", _vm.inputClass] }, [
      _c("input", {
        staticClass: "form-control",
        attrs: {
          type: "search",
          placeholder: _vm.$t("CAMPAIGN_STEP_ROUTING_TARGETS_SEARCH")
        },
        domProps: { value: _vm.search },
        on: {
          input: function($event) {
            return _vm.$emit("change", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.canCreateNew
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary btn-sm pull-right",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("create-new")
              }
            }
          },
          [
            _c("i", { staticClass: "typcn typcn-plus" }),
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("CAMPAIGN_STEP_ROUTING_TARGETS_NEW")) +
                "\n  "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "btn btn-sm bg-transparent letter-spacing-normal pull-right m-r-10",
        attrs: { type: "button", title: _vm.$t("CALL_PLANS_REFRESH_TARGETS") },
        on: {
          click: function($event) {
            return _vm.$emit("refresh")
          }
        }
      },
      [
        _c("i", {
          staticClass: "fa fa-refresh p-0",
          class: { "fa-spin": _vm.isRefreshing }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }